import {defineStore} from "pinia";
import {computed, ref, watch} from "vue";
import * as AvailabilityService from "../services/availability.service";
import {AvailabilityBoat} from "@/models/Boat";
import * as DateUtils from "@/helpers/dateUtils";


export const useRecommendationStore = defineStore('recommendations', () => {


    const state = ref('idle');
    const selectedTab = ref('premium');
    const recommendations = ref<AvailabilityBoat[]>([]);


    const availableTabs = ref(["premium", "standard", "economy"])

    const buildBundle = (yachts) => {
        return {
            count: yachts.length,
            minPrice: Math.min(...yachts.map(o => o.finalPrice)),
            minYear: Math.min(...yachts.map(o => o.yacht.year)),
            maxYear: Math.max(...yachts.map(o => o.yacht.year)),
            models: yachts.map((boat) => boat.yacht.model.name)
        }
    }


    const premium = computed(() => buildBundle(recommendations.value.filter((b) => b.bundle === "premium")));
    const standard = computed(() => buildBundle(recommendations.value.filter((b) => b.bundle === "standard")));
    const economy = computed(() => buildBundle(recommendations.value.filter((b) => b.bundle === "economy")));

    const hasPremium = computed(() => premium.value.count > 0);
    const hasStandard = computed(() => standard.value.count > 0);
    const hasEconomy = computed(() => economy.value.count > 0);

    const getSelectedBundle = computed(() => recommendations.value.filter((b) => b.bundle === selectedTab.value));
    const getSelectedBundleCount = computed(() => getSelectedBundle.value.length);
    const isLoading = computed(() => state.value === "loading");
    
    

    function getAllBundlesBoats(query) {
        state.value = "loading"

        if (selectedTab.value == '') {
            selectedTab.value = 'premium';
        }
        AvailabilityService.searchRecommendations(query)
            .then(response => {
                recommendations.value = response.data;
                state.value = "idle"
            })
            .catch(error => {
                console.error("Failed to fetch boats:", error);
                state.value = "error"

            })

    }

    const handleRoute = async (route) => {
        const query = {
            dateFrom: route.query.dateFrom,
            dateTo:  route.query.dateTo,
            minCabins: parseInt(route.query.cabins as string ?? "0", 10),
            maxCabins: parseInt(route.query.cabins as string ?? "0", 10),
            minBerths: parseInt(route.query.passengers as string ?? "0", 10),
            passengers: route.query.passengers !== undefined ? parseInt(route.query.passengers as string, 10) : undefined,
            yachtModelIds: route.query.yachtModel ? [parseInt(route.query.yachtModel as string ?? "0", 10)] : [],
            yachtCategoryIds: route.query.categories ? [parseInt(route.query.categories as string ?? "0", 10)] : [],
            regionIds: route.query.regionIds || [],
            countryIds: route.query.countryIds || [],
            locationIds: route.query.locationIds || [],
            cityIds: route.query.cityIds || [],
            charterTypeId: route.query.charterTypeId || [],
            price: parseInt(route.query.price as string ?? "0", 10),
            skipper: route.query.skipper === "true",
        };

        console.log("Query from recommendationstore.ts", query);
        

        await getAllBundlesBoats(query);

        // Select the first available tab
        if (premium.value.count > 0) {
            selectedTab.value = "premium";
        } else if (standard.value.count > 0) {
            selectedTab.value = "standard";
        } else if (economy.value.count > 0) {
            selectedTab.value = "economy";
        } else {
            selectedTab.value = "premium"; 
        }
    }

    return {
        state,
        recommendations,
        availableTabs,
        selectedTab,
        getAllBundlesBoats,
        getSelectedBundle,
        getSelectedBundleCount,
        premium,
        standard,
        economy,
        hasPremium,
        hasStandard,
        hasEconomy,
        isLoading,
        handleRoute,
    }

});